<template>
  <div>
    <page-title title="Help" />
    <hr />
    
    <content-block slug="client-help" />
  </div>
</template>

<script>
export default {
  name: 'ClientHelp',
  props: {
  }
}
</script>